module.exports = __webpack_public_path__ + "static/yellow_icon-12010fd3e2c0653c65f4aeb4864005db.png";